import { render, staticRenderFns } from "./PagamentoAssociarDespesas.vue?vue&type=template&id=495d650e"
import script from "./PagamentoAssociarDespesas.vue?vue&type=script&lang=js"
export * from "./PagamentoAssociarDespesas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports